import React from "reactn";
import SectionOne from "./Forms/SectionOne";

class Setup extends React.Component {
  componentDidMount() {
  }

  render() {
    const { automation, onAutomationChange } = this.props;
    return (
      <div className="cont" style={{ 
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px', 
        boxShadow: 'none'
      }}>
        <SectionOne 
          automation={automation}
          onAutomationChange={onAutomationChange}
        />
      </div>
    );
  }
}

export default Setup;